import { lazy, Suspense } from "react";

const lazyWithSkeleton = (importFn, Skeleton) => {
  const LazyComponent = lazy(importFn);

  const WrappedPage = (props) => (
    <Suspense fallback={<Skeleton />}>
      <LazyComponent {...props} />
    </Suspense>
  );

  return WrappedPage;
};

export default lazyWithSkeleton;
